module.exports = __webpack_public_path__ + "img/b2.d7b6b302.png";